<template>
  <div class="p-4 pb-20">
    <!-- Profile Header -->
    <div class="bg-gradient-to-r from-green-600 to-green-700 rounded-xl p-4 text-white mb-4">
      <div class="flex items-center space-x-4">
        <div class="w-16 h-16 bg-white rounded-full flex items-center justify-center">
          <span class="text-2xl font-bold text-green-600">Y</span>
        </div>
        <div class="flex-1">
          <h2 class="text-xl font-bold">Yutthana</h2>
          <p class="text-green-100">Kasetgeny9</p>
          <p class="text-sm text-green-200">Manufacturer Account</p>
        </div>
        <button class="p-2 bg-white/20 rounded-lg hover:bg-white/30 transition-colors">
          <span>✏️</span>
        </button>
      </div>
    </div>

    <!-- Account Information -->
    <div class="bg-white rounded-lg shadow-sm border border-gray-200 mb-4">
      <div class="p-3 border-b border-gray-200">
        <h3 class="font-semibold text-gray-900">Account Information</h3>
      </div>
      <div class="p-4 space-y-3">
        <div class="flex justify-between items-center">
          <span class="text-sm text-gray-600">Account Type</span>
          <span class="text-sm font-medium text-gray-900">Manufacturers</span>
        </div>
        <div class="flex justify-between items-center">
          <span class="text-sm text-gray-600">Login Account</span>
          <span class="text-sm font-medium text-gray-900">Kasetgeny9</span>
        </div>
        <div class="flex justify-between items-center">
          <span class="text-sm text-gray-600">Contact Person</span>
          <span class="text-sm font-medium text-gray-900">Yutthana</span>
        </div>
        <div class="flex justify-between items-center">
          <span class="text-sm text-gray-600">Phone Number</span>
          <span class="text-sm font-medium text-gray-900">+66 621915748</span>
        </div>
        <div class="flex justify-between items-center">
          <span class="text-sm text-gray-600">Email</span>
          <span class="text-sm font-medium text-gray-900">yutthana@kasetgeny.com</span>
        </div>
        <div class="flex justify-between items-center">
          <span class="text-sm text-gray-600">Business License</span>
          <span class="text-sm font-medium text-gray-400">Not provided</span>
        </div>
      </div>
    </div>

    <!-- Quick Actions -->
    <div class="grid grid-cols-2 gap-3 mb-4">
      <button class="bg-blue-600 text-white rounded-lg p-3 flex flex-col items-center space-y-1 hover:bg-blue-700 transition-colors">
        <span class="text-xl">🔑</span>
        <span class="text-sm font-medium">Change Password</span>
      </button>
      <button class="bg-purple-600 text-white rounded-lg p-3 flex flex-col items-center space-y-1 hover:bg-purple-700 transition-colors">
        <span class="text-xl">🖼️</span>
        <span class="text-sm font-medium">Upload Logo</span>
      </button>
    </div>

    <!-- Sub-accounts Management -->
    <div class="bg-white rounded-lg shadow-sm border border-gray-200 mb-4">
      <div class="p-3 border-b border-gray-200 flex items-center justify-between">
        <h3 class="font-semibold text-gray-900">Sub-accounts Management</h3>
        <button class="bg-green-600 text-white px-3 py-1 rounded-lg text-sm font-medium hover:bg-green-700 transition-colors">
          + Create
        </button>
      </div>
      
      <!-- Search and Filter -->
      <div class="p-3 border-b border-gray-200">
        <div class="flex items-center space-x-2">
          <div class="flex-1 relative">
            <input 
              type="text" 
              placeholder="Search sub-accounts..."
              class="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-green-500 focus:border-green-500"
            >
            <span class="absolute left-3 top-2.5 text-gray-400">🔍</span>
          </div>
          <select class="px-3 py-2 border border-gray-300 rounded-lg text-sm">
            <option>All</option>
            <option>Name</option>
            <option>Username</option>
            <option>Phone</option>
          </select>
        </div>
      </div>

      <!-- Sub-accounts List -->
      <div class="divide-y divide-gray-100">
        <div v-for="account in subAccounts" :key="account.id" class="p-3">
          <div class="flex items-center justify-between mb-2">
            <div class="flex items-center space-x-3">
              <div class="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center">
                <span class="text-gray-600 font-semibold">{{ account.username.charAt(0) }}</span>
              </div>
              <div>
                <p class="font-medium text-gray-900">{{ account.username }}</p>
                <p class="text-sm text-gray-500">{{ account.subAccount }}</p>
              </div>
            </div>
            <label class="relative inline-flex items-center cursor-pointer">
              <input 
                type="checkbox" 
                :checked="account.status === 'Active'"
                class="sr-only peer"
                @change="toggleAccountStatus(account.id)"
              >
              <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-green-600"></div>
            </label>
          </div>
          
          <div class="flex items-center justify-between">
            <div class="text-xs text-gray-500">
              <span>📱 {{ account.mobile }}</span>
            </div>
            <div class="flex space-x-2">
              <button class="px-2 py-1 bg-blue-600 text-white rounded text-xs hover:bg-blue-700 transition-colors">
                Edit
              </button>
              <button class="px-2 py-1 bg-purple-600 text-white rounded text-xs hover:bg-purple-700 transition-colors">
                Permission
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="p-3 text-center text-sm text-gray-500">
        Total: 2 sub-accounts
      </div>
    </div>

    <!-- Additional Settings -->
    <div class="bg-white rounded-lg shadow-sm border border-gray-200">
      <div class="p-3 border-b border-gray-200">
        <h3 class="font-semibold text-gray-900">Settings</h3>
      </div>
      <div class="divide-y divide-gray-100">
        <button class="w-full p-3 flex items-center justify-between hover:bg-gray-50 transition-colors">
          <div class="flex items-center space-x-3">
            <span class="text-xl">🔔</span>
            <span class="text-sm font-medium text-gray-900">Notifications</span>
          </div>
          <span class="text-gray-400">›</span>
        </button>
        
        <button class="w-full p-3 flex items-center justify-between hover:bg-gray-50 transition-colors">
          <div class="flex items-center space-x-3">
            <span class="text-xl">🌐</span>
            <span class="text-sm font-medium text-gray-900">Language</span>
          </div>
          <span class="text-sm text-gray-500">English ›</span>
        </button>
        
        <button class="w-full p-3 flex items-center justify-between hover:bg-gray-50 transition-colors">
          <div class="flex items-center space-x-3">
            <span class="text-xl">📊</span>
            <span class="text-sm font-medium text-gray-900">Data & Privacy</span>
          </div>
          <span class="text-gray-400">›</span>
        </button>
        
        <button class="w-full p-3 flex items-center justify-between hover:bg-gray-50 transition-colors">
          <div class="flex items-center space-x-3">
            <span class="text-xl">❓</span>
            <span class="text-sm font-medium text-gray-900">Help & Support</span>
          </div>
          <span class="text-gray-400">›</span>
        </button>
        
        <button class="w-full p-3 flex items-center justify-between hover:bg-gray-50 transition-colors text-red-600">
          <div class="flex items-center space-x-3">
            <span class="text-xl">🚪</span>
            <span class="text-sm font-medium">Logout</span>
          </div>
          <span class="text-gray-400">›</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const subAccounts = ref([
  {
    id: 1,
    username: 'TEST01',
    subAccount: 'kasetgeny',
    mobile: '0884444445',
    status: 'Active'
  },
  {
    id: 2,
    username: 'scrasil',
    subAccount: 'kasetgeny',
    mobile: '0643619678',
    status: 'Active'
  }
])

const toggleAccountStatus = (accountId) => {
  const account = subAccounts.value.find(acc => acc.id === accountId)
  if (account) {
    account.status = account.status === 'Active' ? 'Inactive' : 'Active'
  }
}
</script>
